import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {SnackBarService} from '@core/services/snack-bar.service';
import {ActivityFilterDateRangeTypes, ActivityFilterDateRangeTypesList} from '@shared/models/activity-tracker-header.model';
import {TimeZoneService} from '@core/services/time-zone.service';
import {ActivityFilterService} from '@features/task-manager/collaboration/services/activity-filter.service';

@Component({
    standalone: false,
    selector: 'particle-activity-filter-date-range-selector',
  templateUrl: './activity-filter-date-range-selector.component.html',
  styleUrls: ['./activity-filter-date-range-selector.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ActivityFilterDateRangeSelectorComponent implements OnInit, IDialogView {
  data: DialogModel;
  dateRangeType: string;
  startDate: Date;
  fiscalDate: Date;
  endDate: Date;
  dateRangeTypesList: Array<any> = ActivityFilterDateRangeTypesList;
  dateRangeTypes: any = ActivityFilterDateRangeTypes;
  currentFiscalDate: Date;
  currentDateRangeType: string;
  hideFiscalYearNote = false;
  weekendsDatesFilter = (d: Date): boolean => {
    if(d){
      let currentDate = d.getDate();
      let lastDay = new Date(d.getFullYear(), d.getMonth() + 1, 0);
      let lastDate = lastDay.getDate();
      if(currentDate === lastDate){
        return true;
      }
      return false;
    }
    return false;
  }
  constructor(private snackBarService: SnackBarService, private timeZoneService: TimeZoneService,private activityFilterService: ActivityFilterService) { }

  ngOnInit() {
    this.currentFiscalDate = this.activityFilterService.fiscalYearEnd;
    this.dateRangeType = this.data.input.dateRangeType;
    if (!this.dateRangeType) {
      this.snackBarService.showError('Date range type not found.');
    }
    this.startDate = new Date(this.data.input.startDate);
    this.endDate = new Date(this.data.input.endDate);
    if (this.data.input.hideFiscalYearNote === true) {
      this.hideFiscalYearNote = true;
    }
    if (this.data.input.dateRangeTypesList?.length > 0) {
      this.dateRangeTypesList = this.data.input.dateRangeTypesList;
    }
    if (this.dateRangeType !== ActivityFilterDateRangeTypes.Custom) {
      this.handleDateRangeTypeChange(this.dateRangeType);
    }
  }
  onDateRangeTypeChange($event) {
    this.handleDateRangeTypeChange(this.dateRangeType);
  }


  onFromDate($event: any) {
    this.startDate = $event.value;
    if(this.dateRangeType !== ActivityFilterDateRangeTypes.Custom) {
      this.dateRangeType = ActivityFilterDateRangeTypes.Custom;
    }
  }
  onFiscalDate($event: any) {
    this.activityFilterService.setCurrentFiscalYearDate($event.value);
    this.currentFiscalDate = $event.value;
    this.handleDateRangeTypeChange(this.currentDateRangeType);
  }
  onToDate($event: any) {
    this.endDate = $event.value;
    if(this.dateRangeType !== ActivityFilterDateRangeTypes.Custom) {
      this.dateRangeType = ActivityFilterDateRangeTypes.Custom;
    }
  }

  onOkClicked(): boolean {
    if (!this.dateRangeType) {
      this.snackBarService.showError('Please select a type.');
      return;
    }
    if (!this.startDate) {
      this.snackBarService.showError('Please select a start date.');
      return;
    }
    if (!this.endDate) {
      this.snackBarService.showError('Please select an end date.');
      return;
    }

    if (!this.isValidDateRange()) {
      return false;
    }
    this.data.input.dateRangeType = this.dateRangeType;
    this.data.input.startDate = this.startDate;
    this.data.input.endDate = this.endDate;
    return true;
  }

  private handleDateRangeTypeChange(dateRangeType: string) {
    this.currentDateRangeType = dateRangeType;
    let getDate = this.activityFilterService.getQuater(0);
    switch (dateRangeType) {
      case ActivityFilterDateRangeTypes.Last30Days:
        this.startDate = new Date(new Date().setDate(new Date().getDate() - 29));
        this.endDate = new Date();
        break;
      case ActivityFilterDateRangeTypes.Last90Days:
        this.startDate = new Date(new Date().setDate(new Date().getDate() - 89));
        this.endDate = new Date();
        break;
      case ActivityFilterDateRangeTypes.Today:
        this.startDate = new Date();
        this.endDate = new Date();
        break;
      case ActivityFilterDateRangeTypes.Last7Days:
        this.startDate = new Date(new Date().setDate(new Date().getDate() - 6));
        this.endDate = new Date();
        break;
      case ActivityFilterDateRangeTypes.Quarter1:
        getDate = this.activityFilterService.getQuater(3);
        this.startDate = getDate['BeginDate'];
        this.endDate = getDate['EndDate'];
        break;
      case ActivityFilterDateRangeTypes.Quarter2:
        getDate = this.activityFilterService.getQuater(2);
        this.startDate = getDate['BeginDate'];
        this.endDate = getDate['EndDate'];
        break;
      case ActivityFilterDateRangeTypes.Quarter3:
        getDate = this.activityFilterService.getQuater(1);
        this.startDate = getDate['BeginDate'];
        this.endDate = getDate['EndDate'];
        break;
      case ActivityFilterDateRangeTypes.Quarter4:
        getDate = this.activityFilterService.getQuater(0);
        this.startDate = getDate['BeginDate'];
        this.endDate = getDate['EndDate'];
        break;
      case ActivityFilterDateRangeTypes.Custom:
        this.startDate = new Date(new Date().setDate(new Date().getDate() - 29));
        this.endDate = new Date();
        break;
      default:
        this.dateRangeType = ActivityFilterDateRangeTypes.Last30Days;
        this.startDate = new Date(new Date().setDate(new Date().getDate() - 29));
        this.endDate = new Date();
        break;
    }
  }
  getTypeTextColor(type: any){
    let currentColorClass = {
      color: 'black'
    };
    let getDate = this.activityFilterService.getQuater(3);
    let startDate = getDate['BeginDate'];
    let currentDate = new Date();
    switch (type.id) {
      case ActivityFilterDateRangeTypes.Quarter1:
        getDate = this.activityFilterService.getQuater(3);
        startDate = getDate['BeginDate'];

        if(startDate > currentDate) {
          currentColorClass.color = 'lightgrey';
        }
        break;
      case ActivityFilterDateRangeTypes.Quarter2:
        getDate = this.activityFilterService.getQuater(2);
        startDate = getDate['BeginDate'];

        if(startDate > currentDate) {
          currentColorClass.color = 'lightgrey';
        }
        break;
      case ActivityFilterDateRangeTypes.Quarter3:
        getDate = this.activityFilterService.getQuater(1);
        startDate = getDate['BeginDate'];

        if(startDate > currentDate) {
          currentColorClass.color = 'lightgrey';
        }
        break;
      case ActivityFilterDateRangeTypes.Quarter4:
        getDate = this.activityFilterService.getQuater(0);
        startDate = getDate['BeginDate'];

        if(startDate > currentDate) {
          currentColorClass.color = 'lightgrey';
        }
        break;
    }
    return currentColorClass;
  }
  private isValidDateRange() {
    if (this.startDate.getTime() > this.endDate.getTime()) {
      this.snackBarService.showError('Please select a valid date range.');
      return false;
    }
    if (this.dateRangeType === ActivityFilterDateRangeTypes.Custom) {
      let minStartDate = new Date(JSON.parse(JSON.stringify(this.endDate)));
      // console.log('minStartDate start:', minStartDate);
      minStartDate = new Date(minStartDate.setFullYear(minStartDate.getFullYear() - 1));
      // console.log('minStartDate maxLimit:', minStartDate);
      if (this.startDate.getTime() < minStartDate.getTime()) {
        this.snackBarService.showError('Please select a valid date range. Date range should be less than or equal one year.');
        return false;
      }
    }
    return true;
  }
}
